var _rect, _rect2, _rect3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStartedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 194,
    viewBox: "0 0 252 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120.066,
    y: 35.792,
    width: 27.2014,
    height: 215.061,
    rx: 13.6007,
    transform: "rotate(45 120.066 35.792)",
    fill: "#3360AD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201.211,
    y: 32.7871,
    width: 23.8013,
    height: 285.615,
    rx: 11.9006,
    transform: "rotate(45 201.211 32.7871)",
    stroke: "#3360AD",
    strokeWidth: 3.40018
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.951,
    y: 140.379,
    width: 27.2014,
    height: 175.109,
    rx: 13.6007,
    transform: "rotate(45 166.951 140.379)",
    fill: "#208C72"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.418,
    cy: 130.174,
    r: 14.4508,
    transform: "rotate(45 196.418 130.174)",
    fill: "#F28520"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.471,
    cy: 100.12,
    r: 14.4508,
    transform: "rotate(45 226.471 100.12)",
    fill: "#EA1763"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.938,
    cy: 20.4365,
    r: 12.7507,
    transform: "rotate(45 230.938 20.4365)",
    stroke: "#3360AD",
    strokeWidth: 3.40018
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedBg);
export default __webpack_public_path__ + "static/media/get-started-bg.14b52225f145d989547916be2cebbebe.svg";
export { ForwardRef as ReactComponent };